<template>
  <main class="page content">
    <div class="container">
      <div class="searchHero">
        <h1>Search Results</h1>
        <div>
          <input :value="searchQuery" @input="setSearchQuery($event.target.value)" placeholder="Search" @keyup.enter="submit">
          <button class="button" ref="button" @click="submit"><img src="./search/Search.svg" width="64" height="64"></button>
        </div>
      </div>
      <section class="searchResults" :class="!loading ? '' : 'loading'">
        <search-result v-for="result in results" :result="result" :key="result.slug"></search-result>
        <div v-if="!results || !results.length">
          <h2>No Results</h2>
          <p>Please try another search</p>
        </div>
        <pagination :totalPages="totalPages" v-if="totalPages > 1"></pagination>
      </section>
    </div>
  </main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SearchResult from '@/components/search/SearchResult'
import Pagination from '@/components/common/Pagination'

export default {
  name: 'search',
  data () {
    return {
      page: 1,
      loading: true,
      results: null,
      totalPages: null
    }
  },
  components: {
    SearchResult,
    Pagination
  },
  mounted () {
    if (this.$route.query.page) {
      this.setPage(parseInt(this.$route.query.page), true)
    }
    this.executeSearch()
  },
  methods: {
    submit () {
      let vm = this
      vm.$router.push({name: 'Search', query: {q: vm.searchQuery}})
    },
    executeSearch (scrollToTop = false) {
      let vm = this
      // GET /search => get_search_results() [theme-folder]/api/functions.php
      vm.$axios.get('/search', {
        params: {
          q: vm.$route.query.q,
          page: vm.page
        }
      })
      .then((response) => {
        vm.results = response.data.posts
        vm.totalPages = response.data.pages
        if (scrollToTop) {
          scrollTo(0, 0)
        }
        vm.loading = false
      })
      .catch((err) => {
        vm.loading = false
        console.log(err.response)
      })
    },
    setPage (i, push = false) {
      let vm = this
      vm.page = parseInt(i)
      if (push) {
        vm.$router.push({name: 'Search', query: { q: vm.$route.query.q, page: i }})
      }
    },
    ...mapActions([
      'setSearchQuery'
    ])
  },
  computed: {
    query () {
      return this.$route.query.q
    },
    ...mapGetters([
      'searchQuery'
    ])
  },
  watch: {
    query () {
      this.loading = true
      this.results = null
      this.executeSearch()
    },
    page () {
      this.loading = true
      this.results = null
      this.executeSearch(true)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import ../assets/styles/colors
@import ../assets/styles/mixins

.page
  padding-bottom: 120px
  background: #fff

h2
  font-weight: bold

.searchHero
  margin-bottom: 30px
  +tablet
    display: flex
    margin-bottom: 76px
  h1 
    background: $turqoise
    line-height: 1
    font-weight: bold
    padding: 30px
    margin-bottom: 0
    +tablet
      font-size: 36px
      padding: 36px 72px 36px 36px
      margin: 0 10px 0 0
    +smDesktop
      width: 460px
  > div
    border-bottom: 1px solid
    flex: 1
    position: relative
    input
      width: 100%
      border: none
      line-height: 1
      font-weight: bold
      font-size: 2em
      padding: 24px 30px
      +tablet
        font-size: 36px
        padding: 0 0 0 10px
        height: 108px
    button
      position: absolute
      top: 50%
      transform: translateY(-50%)
      z-index: 5
      padding: 0
      height: 32px
      right: 30px
      img
        width: 32px
        height: 32px
      +tablet
        right: 0
        height: 64px
        img
          width: 64px
          height: 64px
</style>



// WEBPACK FOOTER //
// Search.vue?9efc44b8